module.exports = __webpack_public_path__ + "Bliss2-Bold.f9ed06b5bbb72929f1b6.woff2";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/Bliss2-Bold.woff2
// module id = ../../../../../src/assets/layout/fonts/Bliss2-Bold.woff2
// module chunks = styles